module.exports = __webpack_public_path__ + "img/tymoshenko.22829d32.png";